export default "__VITE_ASSET__BpNe4Ztb__"